import { useEffect, useState } from "react";

import { useNotionDatabase, FigmaImage, PanesContainer } from "dev";

import { TrackingSubstatusCard } from "../[uuid]";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus, Status, Substatus } from "@/src/types";

type NotionEntry = {
  uuid: string;
  tstamp: string;
  status: Status;
  substatus: Substatus<Status>;
  figma_url: string;
  ctas: string;
};

export default function CTAs() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  const [entries, setEntries] = useState<Array<DeliveryStatus & NotionEntry>>(
    []
  );

  const data = db
    ?.map(
      (r) =>
        ({
          uuid: r["Order UUID"],
          tstamp: r["Order Timestamp"],
          status: r["Status"] as Status,
          substatus: r["Sub-status"] as Substatus<Status>,
          figma_url: r["Consumer Figma Link"],
          ctas: r["Consumer CTAs"],
        } as NotionEntry)
    )
    .filter((r) => r.uuid && r.ctas);

  useEffect(() => {
    data?.forEach((r) => {
      if (entries.some((e) => e.uuid === r.uuid)) return;

      fetchDeliveryStatus(r)
        .then((status) => setEntries((prev) => [...prev, { ...r, ...status }]))
        .catch((e) => {
          console.error(e);
        });
    });
  }, [data?.length]);

  return (
    <PanesContainer
      items={entries}
      numColumns={2}
      expectedCount={data?.length}
      renderItem={(deliveryStatus, index) => (
        <>
          <pre>{JSON.stringify(deliveryStatus.tracking_status, null, 2)}</pre>

          <div>
            <p>notion substatus: {deliveryStatus.substatus}</p>
            <a href={deliveryStatus.figma_url}>figma_url</a>
          </div>
          <FigmaImage
            key={index.toString()}
            url={deliveryStatus.figma_url}
            fetchDelayMs={index * 200}
          />

          <MockDeliveryStatusProvider deliveryStatus={deliveryStatus}>
            <TrackingSubstatusCard />
          </MockDeliveryStatusProvider>
        </>
      )}
    />
  );
}
